import $ from 'jquery';
var jQuery = $;

export var wg_ui = {

    ENDPOINT_RESULT_SUCCESS: {},
    ENDPOINT_RESULT_FAILURE: {},

};

var ASYNC_AUTO_RETRY_MAX = 1;
var LONG_POLL_AUTO_RETRY_MAX = 2;
var RETRY_DELAY = 3000; // 3 seconds


wg_ui.redirect = function (url) {
    wg_modal.disableUnloadBlock();
    if (window.location == url)
        window.location.reload();
    else
        window.location = url;
};
wg_ui.reload = function () {
    wg_modal.disableUnloadBlock();
    window.location.reload();
};

wg_ui.getErrorString = function (asyncData, data) {
    var error = (asyncData && asyncData.errorText) ? asyncData.errorText : null;
    if (!error)
        error = (data && data.errorText) ? data.errorText : gettext("Sorry, an unknown error occurred.");
    return error;
};

/**
 * Call an API endpoint.
 *
 * Synchronous and Asynchronous calls are abstracted so the caller does not need to worry about which is which.
 *
 * Upon success or failure, throbber will be hidden.
 *
 * Upon success:
 *      If a redirectSuccessURL was passed from the endpoint
 *          the redirect will be performed and no callback will be called.
 *      Else, if defined, success method will be called with result of endpoint call
 * Upon failure:
 *      If a redirectFailURL was passed from the endpoint
 *          the redirect will be performed and no callback will be called.
 *      Else, auto-retries will be attempted.
 *          After max auto retries has been met:
 *              If failure callback is defined, it will be called with the data sent as a result of the last attempt,
 *              Else, a message will shown below the header.
 *
 * @see https://confluence.wargaming.net/display/WEBDEV/WOTX+Web+Portal+-+Design+-+API#WOTXWebPortal-Design-API-AJAXtoendpoints
 *
 * @param settings  Object containing the following parameters:
 * endpoint             Endpoint URL
 * method               HTTP Method
 * data                 Data to pass to endpoint
 * errortext            Localized error text to show for retry dialog
 * success              Optional JS function to call upon success
 * failure              Optional JS function to call upon failure
 * asyncResultEndpoint  Required for asynchronous calls. The URL of the router which is routing to a specific set of AsyncProxy result server.
 * accountId            Required for asynchronous calls. The account_id for which this call is for.
 * asyncResultHandler   Required for asynchronous calls. A function that will evaluate asynchronous results to determine if the result represents success or if it represents failure, and if so what kind of failure.
 */
wg_ui.callEndpoint = function (settings) {

    var endpoint = settings.endpoint;
    var method = settings.method || 'POST';
    var data = settings.data;
    var success = settings.success;
    var failure = settings.failure;
    var complete = settings.complete;
    var asyncResultEndpoint = settings.asyncResultEndpoint;
    var accountId = settings.accountId;
    var asyncResultHandler = settings.asyncResultHandler;

    var showThisMightTakeAWhile = function () {
        $(wg_modal.THROBBER_SELECTOR).find('p').show(); // show 'one moment...' message
    };

    var callFailureOrShowError = function (xhr, data, asyncData) {
        if (failure) {
            failure(data);
        } else {
            var errorString;
            if (xhr && xhr.status == 0)
                errorString = gettext("An error occurred while contacting our server.");
            else if (asyncData || data)
                errorString = wg_ui.getErrorString(asyncData, data);
            wg_errors.showError(errorString);
            wg_modal.hideThrobber();
        }
    };

    var callSuccessOrDoNothing = function (data) {
        if (success) {
            success(data);
        }
    };

    var callCompleteOrDoNothing = function () {
        if (complete)
            complete();
    };

    var asyncRetryCount = 0;
    var result = {
        xhr: null
    };


    var doAsync = function () {
        result.xhr = $.ajax({
                url: endpoint,
                method: method,
                data: data,
                success: function (data, status, xhr) {
                    // If result has transaction id, start long polling
                    if (data.result_key) {

                        if (!accountId)
                            console.error("Can't start long poll without accountId");
                        if (!asyncResultEndpoint)
                            console.error("Can't start long poll without asyncResultEndpoint");

                        showThisMightTakeAWhile();
                        var longPollRetryCount = 0;
                        var doLongPoll = function () {
                            result.xhr = $.ajax({
                                url: asyncResultEndpoint,
                                data: {result_key: data.result_key, account_id: accountId},
                                success: function (asyncData, status, xhr) {
                                    var handlerResult = asyncResultHandler(asyncData);
                                    if (handlerResult == wg_ui.ENDPOINT_RESULT_SUCCESS) {
                                        if (data.redirectSuccessURL) {
                                            wg_ui.redirect(data.redirectSuccessURL);
                                        } else {
                                            callSuccessOrDoNothing(asyncData.result);
                                        }
                                    } else if (handlerResult == wg_ui.ENDPOINT_RESULT_FAILURE) {
                                        callFailureOrShowError(xhr, data, asyncData);
                                    } else {
                                        callFailureOrShowError(xhr, {'errorText': handlerResult});
                                    }

                                    callCompleteOrDoNothing();
                                },
                                error: function (xhr, status, error) {
                                    var asyncData = error;
                                    try {
                                        asyncData = $.parseJSON(xhr.responseText);
                                    } catch (ex) {
                                        console.log("Error asyncData is not JSON");
                                    }
                                    if (data.redirectFailureURL) {
                                        wg_ui.redirect(data.redirectFailureURL);
                                    } else {
                                        if (longPollRetryCount++ <= LONG_POLL_AUTO_RETRY_MAX) {
                                            setTimeout(doLongPoll, longPollRetryCount * RETRY_DELAY);
                                        } else {
                                            callFailureOrShowError(xhr, data, asyncData);
                                            callCompleteOrDoNothing();
                                        }
                                    }
                                },
                                complete: function (xhr, status) {

                                }
                            });
                        };
                        doLongPoll();
                    } else {
                        if (data.status == "exception" || data.status == "error") { // constants defined in api.py
                            this.error(xhr, "error", null);
                        } else {
                            if (data && data.redirectURL) {
                                wg_ui.redirect(data.redirectURL);
                            } else {
                                callSuccessOrDoNothing(data.result);
                                callCompleteOrDoNothing();
                            }
                        }
                    }
                },
                error: function (xhr, status, error) {
                    if (!xhr.responseText && status == "abort")
                        return;

                    var data = error;
                    try {
                        data = $.parseJSON(xhr.responseText);
                    } catch (ex) {
                        console.log("Error data is not JSON");
                    }
                    if (data && data.redirectURL) {
                        wg_ui.redirect(data.redirectURL);
                    } else if (data && data.reloadShouldFix) {
                        wg_ui.reload();
                    } else {
                        if (data.retryWontfix && asyncRetryCount++ <= ASYNC_AUTO_RETRY_MAX) {
                            showThisMightTakeAWhile();
                            setTimeout(doAsync, asyncRetryCount * RETRY_DELAY);
                        } else {
                            callFailureOrShowError(xhr, data);
                            callCompleteOrDoNothing();
                        }
                    }
                },
                complete: function (xhr, status) {

                }
            }
        )
    };

    doAsync();
    return result;
};

wg_ui.setTableColumnHover = function (namespace, columnSelector, tableSelector) {
    $(columnSelector).on('mouseenter' + namespace + ' mouseleave' + namespace, function (e) {
        wg_ui.setTableColumnHover.addHover($(this), e, tableSelector);
    });
};

wg_ui.setTableColumnHover.addHover = function ($headerCell, e, tableSelector) {

    var $header = $headerCell.parent();
    var headerColumn = 0;
    var $headerCells = $header.children('td, th');
    var headerCell = $headerCell[0];
    // Expand all the colSpans to find the header column index
    for (var i = 0, cell = $headerCells[i]; cell != headerCell; i++, cell = $headerCells[i]) {
        headerColumn += cell.colSpan || 1;
    }

    $(tableSelector + ' tr').not($header).each(function () {
        var $row = $(this);

        var rowColumn = 0;
        var i;
        var cell;

        // Expand all the colSpans to find the cell column index
        for (i = 0, cell = $row.children()[i]; rowColumn < headerColumn; i++, cell = $row.children()[i]) {
            if (!cell)
                return;
            rowColumn += cell.colSpan;
        }

        var $cells = $();
        var span = 0;
        while (span < headerCell.colSpan) {
            $cells = $cells.add($row.children('td, th').eq(i));
            if (!$cells.length)
                return;
            span += $cells.last()[0].colSpan;
            i++;
        }


        var hoveredClass = $cells.data('hovered-class');

        if (e.type === 'mouseenter') {
            $cells.addClass(hoveredClass)
        } else if (e.type === 'mouseleave') {
            $cells.removeClass(hoveredClass)
        }
    });
};

$.fn.renderListBoxIcon = function (src, alt, extraClassNames) {
    var $iconItem = this.addClass(extraClassNames);

    if (/\.svg$/.test(src)) {
        $iconItem.addClass('svg-icon svg-icon__list-box js-svg-icon').attr({
            'data-src': src,
            'title': alt
        });
    } else {
        $iconItem.attr({'src': src, 'alt': alt});
    }
};
